import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useLayoutEffect, useEffect, useRef, useState } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import DropDown from '../ui/react-ui/dropdown';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { getStatsTerminalsDelivery } from '../../api/statsAPI';
import { getAreaTerminals } from '../../api/areaAPI';
import { setStatsTerminalsDelivery, setTerminalsXYTerminalsSelected, setTerminalsXYZonesSelected } from '../../redux/stats-dashboard';
var t = i18n.getFixedT(null, 'stats-dashboard');
var StatsTerminalsXYStackChart = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$statsDas = _useSelector.statsDashboard,
      statsTerminalsDelivery = _useSelector$statsDas.statsTerminalsDelivery,
      dateTime = _useSelector$statsDas.dateTime,
      terminalsXYTerminalsSelected = _useSelector$statsDas.terminalsXYTerminalsSelected,
      terminalsXYZonesSelected = _useSelector$statsDas.terminalsXYZonesSelected,
      zonesList = _useSelector.app.zonesList;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      terminalsList = _useState2[0],
      setTerminalsList = _useState2[1];

  var chartXY = useRef();
  useLayoutEffect(function () {
    chartXY.current = am4core.create('statsTerminalsXYStackChart', am4charts.XYChart);
    am4core.addLicense;
    chartXY.current.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chartXY.current.cursor = new am4charts.XYCursor(); // close zoomXY

    chartXY.current.cursor.behavior = "none"; // Create axes
    // let categoryAxis = chartXY.current.xAxes.push(new am4charts.CategoryAxis())
    // categoryAxis.dataFields.category = 'terminalName'
    // categoryAxis.renderer.grid.template.location = 0
    // categoryAxis.renderer.minGridDistance = 40

    var categoryAxis = chartXY.current.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.dataFields.category = "terminalName";
    categoryAxis.renderer.minGridDistance = 1; // categoryAxis.renderer.inversed = true

    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.cursorTooltipEnabled = false;
    var valueAxis = chartXY.current.xAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minGridDistance = 50;
    valueAxis.min = 0;
    valueAxis.cursorTooltipEnabled = false; // Set up series

    var series = chartXY.current.series.push(new am4charts.ColumnSeries());
    series.name = '領櫃';
    series.dataFields.valueX = 'pickupCount';
    series.dataFields.categoryY = "terminalName"; // series.sequencedInterpolation = true
    // series.columns.template.strokeWidth = 0;
    // series.columns.template.width = am4core.percent(100);
    // series.columns.template.tooltipText = `領櫃: {valueX}`

    series.stacked = true;
    var series2 = chartXY.current.series.push(new am4charts.ColumnSeries());
    series2.name = '交櫃';
    series2.dataFields.valueX = 'returnCount';
    series2.dataFields.categoryY = "terminalName"; // series2.sequencedInterpolation = true
    // series2.columns.template.strokeWidth = 0;
    // series2.columns.template.width = am4core.percent(100);
    // series2.columns.template.tooltipText = `交櫃: {valueX}`

    series2.stacked = true;
    series2.columns.template.adapter.add('tooltipText', function (text, target) {
      var _target$tooltipDataIt = target.tooltipDataItem.dataContext,
          pickupCount = _target$tooltipDataIt.pickupCount,
          returnCount = _target$tooltipDataIt.returnCount,
          terminalName = _target$tooltipDataIt.terminalName;
      target.tooltip.getFillFromObject = false;
      target.tooltip.background.fill = am4core.color("#000");
      var pickupText = "\u9818\u6AC3: ".concat(pickupCount);
      var returnText = "\u4EA4\u6AC3: ".concat(returnCount);
      return "".concat(terminalName, "\n").concat(pickupText, "\n").concat(returnText);
    }); // Configure columns
    // series.columns.template.width = am4core.percent(60)
    // series.columns.template.tooltipText = `{valueY}${type==='termanal' ? '輛' : '分'}`
    // Add label
    // let labelBullet = series.bullets.push(new am4charts.LabelBullet())
    // // labelBullet.label.text = "{valueY}"
    // labelBullet.locationY = 0.5
    // labelBullet.label.hideOversized = true
    // Add a legend
    // chartXY.current.legend = new am4charts.Legend()
    // chartXY.current.legend.position = "bottom"

    chartXY.current.data = _.map(statsTerminalsDelivery, function (el) {
      return {
        terminalName: el.terminalName,
        returnCount: el.returnCount,
        pickupCount: el.pickupCount
      };
    }); // hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chartXY.current.dispose();
    };
  }, [JSON.stringify(statsTerminalsDelivery)]); // useEffect(() => {
  //     chartXY.current.data = _.map(statsTerminalsDelivery, el => ({
  //         terminalName: el.terminalName,
  //         returnCount: el.returnCount,
  //         pickupCount: el.pickupCount
  //     }))
  // }, [JSON.stringify(statsTerminalsDelivery)])

  useEffect(function () {
    if (terminalsXYZonesSelected === '') return setTerminalsList([]);
    getAreaTerminals(contextRoot, true, terminalsXYZonesSelected, null, 0, null, null, true).then(function (result) {
      var list = _.map(result.content, function (el) {
        return {
          value: el.id,
          text: el.name
        };
      });

      setTerminalsList(list);
    });
  }, [terminalsXYZonesSelected]);

  var handleChangeZones = function handleChangeZones(zoneId) {
    dispatch(setTerminalsXYZonesSelected(zoneId));
    dispatch(setTerminalsXYTerminalsSelected(''));
    getStatsTerminalsDelivery(contextRoot, false, zoneId, '', dateTime).then(function (data) {
      dispatch(setStatsTerminalsDelivery(_.isEmpty(data.content) ? 'noData' : data.content));
    });
  };

  var handleChangeTerminals = function handleChangeTerminals(terminalId) {
    dispatch(setTerminalsXYTerminalsSelected(terminalId));
    getStatsTerminalsDelivery(contextRoot, false, terminalsXYZonesSelected, terminalId, dateTime).then(function (data) {
      dispatch(setStatsTerminalsDelivery(_.isEmpty(data.content) ? 'noData' : data.content));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "chart-dropdown"
  }, /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals-center'),
    list: zonesList,
    value: terminalsXYZonesSelected,
    onChange: handleChangeZones,
    width: "200px"
  }), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals'),
    list: terminalsList,
    value: terminalsXYTerminalsSelected,
    onChange: handleChangeTerminals,
    width: "200px"
  })), statsTerminalsDelivery === 'noData' ? /*#__PURE__*/React.createElement("div", {
    className: "stats-terminals-xy-stack-chart-nodata"
  }, t('lbl-no-data')) : /*#__PURE__*/React.createElement("div", {
    id: "statsTerminalsXYStackChart"
  }));
});
export default StatsTerminalsXYStackChart;